import styled from 'styled-components'

export const EstadoWrapper = styled('div')`
  background-color: ${({ estado, theme }) =>
    estado === 'finalizada' ? theme.colors.grey72 : theme.colors.extra.ultraLighten};
  border-radius: 8px;
  padding: 6px 15px;

  ${({ fitContent }) => fitContent && `width: fit-content;`}
`

export const ChipsContainer = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    margin-bottom: 0px;
    margin-right: 24px;
  }
`
